/**
 * Classe que gerencia o grid dos smartgeocodes
 * @author: Adalto Junior adaltojunior@sagaranatech.com
 * DATE: 31/01/2012
 * @version: 1.0
 *
 */


Greenmile.SmartGeocode = Greenmile.SmartGeocode || {};

Greenmile.SmartGeocode.Grid = function () {

    var entity = 'SmartGeocode';

    var formatterColumns = function (row, cell, value, column, dataContext) {

        var id;

        if (value) {

            if (column.field === "averageDistance") {
                value = new Greenmile.Calculos.GeneralFunctions().formatDistanceOnKmOrMilles(value);
            }

            if (column.field === "locationGeocodingDate" || column.field === "locationGeocodingLastCheck") {
                value = Monet.Format.Date.formatToLocale(value);
            }

        }

        if (column.field === "seeOnMap") {

            id = dataContext.model.get('locationId');

            value = '<a href="#/SmartGeocode/' + id + '/detail"><div class="iconMap"></div></a>';

        }

        return value;
    };

    var getTitleToMathDistanceAverage = function () {

        var unitySystemMetric = new Greenmile.Calculos.GeneralFunctions().getUnitSystemToColumnGrid();
        return " (" + unitySystemMetric + ")";

    };

    this.getColumns = async function () {

        var error     = null,
            mapColumn = {
                cssClass: "cell-row",
                defaultSortAsc: true,
                entity: "SmartGeocode",
                field: "seeOnMap",
                name: Monet.I18n.getResourcesByKey("SmartGeocode.Grid.seeOnMap"),
                formatter: formatterColumns,
                width: 100,
                sortable: false,
                resizable: false
            },
            layout,
            router,
            columns;

        try {

            if (!App.Forms[entity].layout) {

                App.Forms[entity].layout = {};

            }

            layout = App.Forms[entity].layout;

            if (!layout.index) {
                router = new App.Routers.SmartGeocode();
                await router.getColumnsToGridLayout();
                layout = App.Forms[entity].layout;
            }

            columns = Monet.Grid.getGridLayout(layout.index, entity);

            for (var i = 0; i < columns.length; i++) {

                var column = columns[i];

                if (column.field === 'mathDistanceAverage') {
                    column.name += getTitleToMathDistanceAverage();
                }

                column.formatter = formatterColumns;

            }

            columns.push(mapColumn);

            return columns;


        } catch (e) {

            error = new Monet.Exception.ReturnError(this, 'Error on get columns to SmartGeocode', e);
            error.console();

        }

    };

    this.show = async function () {

        var error   = null,
            options = {
                entity: 'SmartGeocode',
                columnCheckBox: {
                    show: false
                },
                columnEdit: {
                    show: false
                },
                sortBy: 'client',
                frozenColumn: -1,
                gridContainner: '#gridSmartGeocode',
                multiColumnSort: true,
                rowHeight: 50
            },
            router;

        try {
            var columns = await this.getColumns();
            var indexColumnFrozen = Monet.Grid.getIndexFrozenColumn(App.Forms.SmartGeocode.layout.index);

            if (indexColumnFrozen !== -1) {
                options.frozenColumn = indexColumnFrozen;
            }


            var customizeColumns = new Monet.Grid.ActionsModules.CustomizeColumns();
            var saveGridLayout = new Monet.Grid.ActionsModules.SaveGridLayout();
            var dataView = new Monet.Grid.DataProvider(columns, null, options.entity);
            var grid = new Monet.Grid.GenericGrid(options.gridContainner, dataView, columns, options);
            var selectorToActions = '#SmartGeocode .actions';

            var updateGrid = function () {
                router.updateGrid(
                    router.getFilter(),
                    Monet.Grid.addDataToGrid,
                    true
                );
            };

            customizeColumns.setEntity('SmartGeocode');
            customizeColumns.setScreenName('SmartGeocode');
            customizeColumns.setSelector(selectorToActions);
            customizeColumns.setElement(document.querySelector(selectorToActions));
            customizeColumns.setCallBacks({
                afterSaveList: function () {
                    App.Views.SmartGeocode.showGrid();
                }
            });

            customizeColumns.init();

            saveGridLayout.setEntity('SmartGeocode');
            saveGridLayout.setScreenName('SmartGeocode');
            saveGridLayout.setSelector(selectorToActions);
            saveGridLayout.setElement(document.querySelector(selectorToActions));
            saveGridLayout.setCallBacks({
                afterSaveList: function () {
                    App.Views.SmartGeocode.showGrid();
                }
            });

            saveGridLayout.init();

            router = new App.Routers.SmartGeocode();

            App.Forms.SmartGeocode.pagination.first = 0;

            updateGrid();

            App.Forms.SmartGeocode.table = grid;
            App.Forms.SmartGeocode.dataProvider = dataView;


        } catch (e) {

            error = new Monet.Exception.ReturnError(this, 'Error on create grid smartgeocode', e);
            error.console();

        }

    };

};
